import Vue, { h } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import utils from '@/utils/utils';
import '@/icons';
import '@/utils/antDesignPicker';
import '@/utils/elementUIPicker';
import '@/assets/global.less';
import sensors from '@/utils/sensors';
import customDirectives from '@/utils/customDirectives';
import Ellipsis from '@/components/common/Ellipsis';
import UserProfiles from '@/components/User/Profiles';

Vue.use(Ellipsis);
Vue.use(UserProfiles);
Vue.use(customDirectives);

Vue.prototype.utils = utils;
Vue.prototype.$sensors = sensors;
Vue.prototype.$deepCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

Vue.config.productionTip = false;

const bus = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
Vue.prototype.$bus = bus;
